var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c("div", { staticClass: "chat-bot" }, [
      _vm.listData.length > 0
        ? _c(
            "div",
            { staticClass: "reset-button" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "text" },
                  on: { click: _vm.resetData },
                },
                [
                  _c("div", { staticClass: "reset-img" }, [
                    _c("img", {
                      staticClass: "img",
                      attrs: {
                        src: require("@/assets/chatbot/chatbotIcon-clear.png"),
                        alt: "",
                      },
                    }),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chat-bot-container", attrs: { id: "scrollContainer" } },
        [
          _vm.listData.length === 0
            ? _c("div", { staticClass: "chat-link" }, [
                _c("div", { staticClass: "box-title" }, [
                  _c("div", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.$t("Chatbot.Chatbot_tips"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box-group" },
                  _vm._l(_vm.recommendList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "box",
                        on: {
                          click: function ($event) {
                            return _vm.sendQuestion(item)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "title text_cut_3" }, [
                          _vm._v(_vm._s(item)),
                        ]),
                        _vm._v(" "),
                        _vm._m(0, true),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.listData, function (item, index) {
            return _c("div", { key: index }, [
              item["type"] === "question"
                ? _c("div", { staticClass: "chat-right" }, [
                    _c("div", { staticClass: "info-wrap" }, [
                      _c("div", { staticClass: "info" }, [
                        _c("div", { staticClass: "text" }, [
                          _vm._v(_vm._s(item["data"])),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              item["type"] === "answer"
                ? _c("div", { staticClass: "chat-left" }, [
                    _vm._m(1, true),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-wrap" }, [
                      _c("div", { staticClass: "info" }, [
                        _c(
                          "div",
                          { staticClass: "text" },
                          [
                            item.data
                              ? _c("VueMarkdown", {
                                  attrs: { source: item.data },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item["event"] != "finish"
                              ? _c("div", { staticClass: "loading-img" }, [
                                  _c("img", {
                                    staticClass: "img",
                                    attrs: {
                                      src: require("@/assets/chatbot/chatbotIcon-loading.gif"),
                                      alt: "",
                                    },
                                  }),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "action" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "chat-action-button btn",
                                attrs: { "data-clipboard-text": item.data },
                                on: { click: _vm.copyLink },
                              },
                              [
                                _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src: require("@/assets/chatbot/chatbotIcon-copy.png"),
                                    alt: "",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            item.feedBackType === ""
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "chat-action-button",
                                    on: {
                                      click: function ($event) {
                                        return _vm.feedBackAnswer(
                                          item.requestId,
                                          1,
                                          "good"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("@/assets/chatbot/chatbotIcon-like.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.feedBackType === "good"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "chat-action-button",
                                    on: {
                                      click: function ($event) {
                                        return _vm.feedBackAnswer(
                                          item.requestId,
                                          2,
                                          "good"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("@/assets/chatbot/chatbotIcon-like2.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.feedBackType === ""
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "chat-action-button",
                                    on: {
                                      click: function ($event) {
                                        return _vm.feedBackAnswer(
                                          item.requestId,
                                          1,
                                          "badcase"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("@/assets/chatbot/chatbotIcon-dislike.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.feedBackType === "badcase"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "chat-action-button",
                                    on: {
                                      click: function ($event) {
                                        return _vm.feedBackAnswer(
                                          item.requestId,
                                          2,
                                          "badcase"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("@/assets/chatbot/chatbotIcon-dislike2.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "chat-action-button",
                                on: {
                                  click: function ($event) {
                                    return _vm.rebuildAnswer(item.requestId)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src: require("@/assets/chatbot/chatbotIcon-refresh.png"),
                                    alt: "",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.knowledgeType === "1" && _vm.isDemo
        ? _c(
            "div",
            { staticClass: "chat-bot-quick-reply" },
            _vm._l(this.optConfig.chatbotTypeList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "quick-reply-item",
                  class: item["code"] === _vm.type ? "active" : "",
                  on: {
                    click: function ($event) {
                      return _vm.changeType(item["code"])
                    },
                  },
                },
                [_vm._v(_vm._s(item["name"]))]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "chat-bot-footer" }, [
        _c(
          "div",
          { staticClass: "chat-input" },
          [
            _c(
              "div",
              { staticClass: "input-inner" },
              [
                _c("el-input", {
                  ref: "inputRef",
                  attrs: {
                    type: "textarea",
                    autosize: "",
                    placeholder: _vm.$t("Chatbot.Chatbot_input_placeholder"),
                  },
                  nativeOn: {
                    keydown: function ($event) {
                      return _vm.handleKeydown($event)
                    },
                  },
                  model: {
                    value: _vm.inputVal,
                    callback: function ($$v) {
                      _vm.inputVal = $$v
                    },
                    expression: "inputVal",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-button", {
              staticClass: "chat-button",
              attrs: {
                icon: "el-icon-top",
                disabled: _vm.disableSendQuestion(),
                circle: "",
              },
              on: { click: _vm.clickShowSalary },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("i", { staticClass: "el-icon-arrow-right" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "avatar-img" }, [
      _c("img", {
        staticClass: "img",
        attrs: { src: require("@/assets/chatbot/chatbotIcon-ai.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }